import {
  Appointment,
  APPOINTMENT_STATUS,
  QUEUE_TYPE,
  SUBJECT_KEYS,
} from "@elixir/types";
import { ChipWithTooltip } from "ui";
import useQueueStore from "../../../../stores/queue-store";
import { onAppointmentAction } from "../../../../utils/bridges/methods";
import { CirclePlayRegularIcon, PrescriptionSolidIcon } from "@elixir/icons";
import { getQueueTypeFromStatus } from "../../../../utils/appointment-utils";
import { getAclViewClassName } from "@elixir/utils";

const WriteRxButton = ({
  apt,
  className = "",
  type,
}: {
  apt: Appointment;
  className?: string;
  type?: "primary" | "secondary";
}) => {
  const isOngoing = apt.status === APPOINTMENT_STATUS.ONGOING;
  const clinicId = useQueueStore((state) => state.clinicId);
  const queueType = getQueueTypeFromStatus(apt.status);
  const isDisabled =
    queueType !== QUEUE_TYPE.CHECKED_IN && queueType !== QUEUE_TYPE.BOOKED;

  return (
    <ChipWithTooltip
      title={isOngoing ? "Resume" : "Write"}
      tooltipText={isOngoing ? "Resume Visit" : "Write Prescription"}
      icon={
        isOngoing ? (
          <CirclePlayRegularIcon />
        ) : (
          <PrescriptionSolidIcon className="dr-w-12 dr-h-12 dr-min-w-12" />
        )
      }
      className={`${className} ${isOngoing ? "dr-text-darwin-touch-green-primary hover:dr-text-darwin-touch-green-primary hover:dr-bg-darwin-touch-green-bg-light hover:dr-border-darwin-touch-green-primary dr-border-darwin-touch-green-primary" : ""} ${getAclViewClassName(SUBJECT_KEYS.START_VISIT)}`}
      type={type}
      onClick={() => {
        onAppointmentAction({
          a: apt,
          cId: clinicId,
          openVideoCallWindow: !isOngoing,
        });
      }}
      isDisabled={isDisabled}
    />
  );
};

export default WriteRxButton;
